module.exports = __webpack_public_path__ + "static/gallery-6-977968ac9e14c1e7a6ab2458c70601c6.jpg";